import { CroppingPatternReportModel } from "@agroyaar/sdk";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import { Table } from "@/shared/components/report-template/presentation/components/common/Table";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";
import Description from "@/shared/components/report-template/presentation/components/common/Description";
import { suggestedAreaColumns } from "@/features/reports/presentation/components/cropping-pattern/constants/suggested-area-header-table";

interface OptimalSuggestedAreaProps {
  croppingPatternReports: CroppingPatternReportModel[];
}

const OptimalSuggestedArea = ({
  croppingPatternReports,
}: OptimalSuggestedAreaProps) => {
  return (
    <ReportTemplate serviceType="CROPPING_PATTERN" pageNumber={3}>
      <div className="w-full flex flex-col gap-3">
        <Title>تخصیص مساحت بهینه کاشت محصولات</Title>

        <Description>
          {" "}
          در این بخش، با در نظر گرفتن محدودیت‌های منابع آبی، شاخص ترکیبی الگوی
          کشت و هدف حداکثرسازی سود، تخصیص بهینه مساحت برای محصولات منتخب شامل{" "}
          <span className="font-semibold text-[18px] leading-[28px] !font-[B-Nazanin]">
            {croppingPatternReports
              .map((report) => report.crop.persianName)
              .join("، ")}{" "}
          </span>{" "}
          انجام شده است.
        </Description>

        <Description>
          تخصیص مساحت به محصولات براساس معیارهای زیر لحاظ شده است.
        </Description>

        <ul className=" list-disc list-inside flex flex-col gap-3 my-10">
          <li className="leading-[28px] font-bold !font-[B-Nazanin] text-[16px]">
             بالاترین شاخص ترکیبی الگوی کشت
          </li>
          <li className="leading-[28px] font-bold !font-[B-Nazanin] text-[16px]">
             کمترین میزان مصرف آب و درنظر گرفتن منابع آب موجود
          </li>
        </ul>

        <Description>
          با توجه به این محدودیت‌ها، محصولاتی که دارای شاخص ترکیبی الگوی کشت
          بالا و در عین حال نیاز آبی کمتر بوده‌اند، اولویت بیشتری برای کشت پیدا
          کرده‌اند.
        </Description>

        <div className="my-10">
          <Table columns={suggestedAreaColumns} data={croppingPatternReports} />
        </div>
      </div>
    </ReportTemplate>
  );
};

export default OptimalSuggestedArea;
